import GPS from './gps_togcj.js'
import store from '@/store/index.js'
let map = null;
let lineDatas = [];
var arrLog = ''

let vm = null
Tmap.prototype.sendThis=function(_this){
  vm = _this
}
function Tmap(mapid) {

	if(this.i > 0) {
		clearInterval(this._timer)
		this.i = 0
	}
	this.map = ''
	this.Area = 0
	this.MathArea = 0
	this.drawArr = []
	this.lineArr = [] //轨迹或标记点数组
	// this._timer = '',//定时器明称
	this.i = 0,
		this.lineLog = [], //回放路线
		this.speed = 600 //轨迹回放速度
	this.fist = true,
		this.TimeOut = 0
	this.lastLinePoints = [],
		this.flag = true
	this.btnName = ''
	this.markerLngLat = '',
		this.lastLine = ''
}
Tmap.prototype.init = function(container, size) {
	var zoom = size
	//初始化地图对象
	this.map = new T.Map(container)
	//设置显示地图的中心点和级别
	this.map.centerAndZoom(new T.LngLat(108.970611, 34.282389), zoom)
	//允许鼠标滚轮缩放地图
	this.map.enableScrollWheelZoom()
	this.map.enableInertia()
	this.map.setMapType(TMAP_HYBRID_MAP)
}
Tmap.prototype.inits = function(container, size) {
	var zoom = size
	//初始化地图对象
	this.map = new T.Map(container)
	//设置显示地图的中心点和级别
	this.map.centerAndZoom(new T.LngLat(108.970611, 34.282389), zoom)
	//允许鼠标滚轮缩放地图
	this.map.enableScrollWheelZoom()
	this.map.enableInertia()
	// this.map.setMapType(TMAP_HYBRID_MAP)
}
//标记点
Tmap.prototype.addMark = function(markPonit, showMarke, showInfo) {
	var points = []
	var icon
	var lnglat
	for(var i = 0; i < markPonit.length; i++) {
		// lnglat = GPS.gcj_decrypt_exact(Number(markPonit[i].lat), Number(markPonit[i].lng))
		// points.push(new T.LngLat(lnglat.lon, lnglat.lat));//轨迹展示数据转换
		points.push(new T.LngLat(markPonit[i].lng, markPonit[i].lat)); //轨迹展示数据
		//向地图上添加标注
		//添加点
		if(showMarke) {
			icon = new T.Icon({
				iconUrl: require("../img/move.png"),
				iconSize: new T.Point(38, 54),
				iconAnchor: new T.Point(10, 25)
			});
			var marker = new T.Marker(new T.LngLat(markPonit[i].lng, markPonit[i].lat), {
				icon: icon
			});
			this.map.addOverLay(marker);
			//添加位置信息弹
			var lnglat = new T.LngLat(markPonit[i].lng, markPonit[i].lat);
			var infoWin = new T.InfoWindow();
			infoWin.setLngLat(lnglat);
			//设置信息窗口要显示的内容i
			infoWin.setContent(markPonit[i].area);
			this.map.addOverLay(infoWin);
		}

		//点击弹出信息框
		//   this.attribute(markPonit[i].content,marker)
	}
	//添加轨迹到地图
	var line = new T.Polyline(points, {
		color: "red"
	});
	this.map.addOverLay(line);
}
Tmap.prototype.playTrackIncremental = function(pointArray, len) {
	let plen = pointArray.length
	let points = []
	for(var i = 0; i < plen; i++) {
		points.push(new T.LngLat(pointArray[i].lng, pointArray[i].lat))
	}

	var line = new T.Polyline(points, {
		color: 'yellow'
	})
	points = []
	//向地图上添加线
	this.map.addOverLay(line)

	this.fist = false
	this.i = 0
	this.lineLog = pointArray
	this._timer = setInterval(this.onlyAddmarker.bind(this), 100)
}
//清除覆盖物
Tmap.prototype.clearOverLays = function() {
	this.map.clearOverLays();
}
//轨迹点击放大照片
Tmap.prototype.addMarkPic = function(markPonit) {
	var points = []
	var icon
	var lnglat
	var marker
	for(var i = 0; i < markPonit.length; i++) {
		lnglat = GPS.gcj_decrypt_exact(Number(markPonit[i].lat), Number(markPonit[i].lng))
		//向地图上添加标注
		icon = new T.Icon({
			iconUrl: require('../img/move.png'),
			iconSize: new T.Point(19, 27),
			iconAnchor: new T.Point(10, 25),
			imgUrl: markPonit[i].pictureUrl
		});
		marker = new T.Marker(new T.LngLat(lnglat.lon, lnglat.lat), {
			icon: icon
		});
		this.map.addOverLay(marker)
		marker.addEventListener('click', function(e) {
			var img = e.target.options.icon.options.imgUrl
			//弹窗
			var infoWin1 = new T.InfoWindow();
			var contentString = '<div style="width: 300px;height100px;margin: 0 auto;display: block;">' +
				'<img  style="width: 95%;margin: 0 auto;display: block;" layer-src="' +
				img + '"  src="' + img + '" alt="">' +
				'</div>'
			infoWin1.setContent(contentString);
			e.target.openInfoWindow(infoWin1)
		})
	}
}
//弹窗控制
Tmap.prototype.attribute = function(content, marker) {
	marker.addEventListener("click", function(e) {
		var p = e.target;
		//弹窗
		var infoWin1 = new T.InfoWindow();
		var sContent =
			"<div style='margin:0px;'>" +
			"<div style='margin:10px 10px; '>" +
			"<div style='margin:10px 0px 10px 0px;'>" + content +
			"</div>";
		infoWin1.setContent(sContent);
		e.target.openInfoWindow(infoWin1)
	});
}
//计算面积
var i = 0
Tmap.prototype.area = function() {
	var config = {
		showLabel: false,
		map: this,
		index: i,
		color: "blue",
		weight: 3,
		opacity: 0.5,
		fillColor: "#FFFFFF",
		fillOpacity: 0.5
	};
	i++
	//创建标注工具对象
	var polygonTool = new T.PolygonTool(this.map, config);
	polygonTool.open()
	polygonTool.addEventListener("draw", this.location);

}
var j = 0
Tmap.prototype.location = function(e) {
	var area = e.currentArea / 666
	var obj = {
		latlng: e.currentLnglats,
		arr: area,
		index: j
	}
	j++
	this.options.map.drawArr.push(obj)
	this.options.map.Area += area
	//提示面积信息
	var lnglat = new T.LngLat(e.currentLnglats[0].lng, e.currentLnglats[0].lat);
	var infoWin = new T.InfoWindow();
	infoWin.setLngLat(lnglat);
	//设置信息窗口要显示的内容
	infoWin.setContent("面积:" + area + '亩');
	//向地图上添加信息窗口
	console.log(this.options.index)
	infoWin.addEventListener("clickclose", () => {
		for(var i = 0; i < this.options.map.drawArr.length; i++) {
			if(this.options.index === this.options.map.drawArr[i].index) {
				this.options.map.drawArr.splice(i, 1)
			}
		}
		this.clear()
		this.options.map.Area = 0
		for(var j = 0; j < this.options.map.drawArr.length; j++) {
			this.options.map.Area += this.options.map.drawArr[j].arr
		}
	});
	this.options.map.map.addOverLay(infoWin);

}
//仅仅向地图添加markers点
// var arrLog = []
// Tmap.prototype.onlyAddmarker = function(i){

//   if(this.i>=this.lineLog.length){
//     clearInterval(this._timer)
//     this.i = 0
//   }
//   var icon = new T.Icon({
//     iconUrl: require("../img/tuolaji.png"),
//     iconSize: new T.Point(19, 27),
//     iconAnchor: new T.Point(10, 25)
//   });
//   this.i++
//   var marker
//   console.log(this.i)
//   marker = new T.Marker(new T.LngLat(this.lineLog[this.i-1].lag, this.lineLog[this.i-1].lat), {icon: icon});
//   arrLog.push(marker)
//   this.map.clearOverLays(arrLog[this.i-1])
//   this.map.addOverLay(marker);
//   var points = []
//   var parameter = this.lineLog
//   for(var i=0;i<parameter.length;i++){
//     points.push(new T.LngLat(parameter[i].lag, parameter[i].lat))
//   }
//   //创建线对象
//   var line = new T.Polyline(points);
//   //向地图上添加线
//   this.map.addOverLay(line);
// }
// //小车回放
// Tmap.prototype.playBack = function (parameter , name) {
//   this.lineLog = parameter
//   if(this.fist){
//     var icon = new T.Icon({
//       iconUrl: require("../img/tuolaji.png"),
//       iconSize: new T.Point(19, 27),
//       iconAnchor: new T.Point(10, 25)
//     });

//     var marker
//     marker = new T.Marker(new T.LngLat(this.lineLog[0].lag, this.lineLog[0].lat), {icon: icon});
//     this.map.addOverLay(marker);
//     var points = []
//     var parameter = this.lineLog
//     for(var i=0;i<parameter.length;i++){
//       points.push(new T.LngLat(parameter[i].lag, parameter[i].lat))
//     }
//     //创建线对象
//     var line = new T.Polyline(points);
//     //向地图上添加线
//     this.map.addOverLay(line);
//   }

//   //运动相关

//   if (name =='satrt') { //开始
//     clearInterval(this._timer)
//     this.i = 0
//     this.fist =false
//     this._timer = setInterval(this.onlyAddmarker.bind(this), 800)
//   }else if(name =='add') { // 加速
//     this.fist =false
//     clearInterval(this._timer)
//     this._timer = setInterval(this.onlyAddmarker.bind(this), 400)
//   }else if(name =='sub'){//减速
//     this.fist =false
//     clearInterval(this._timer)
//     this._timer = setInterval(this.onlyAddmarker.bind(this), 1200)
//   }else if(name =='stop'){//停止
//     this.fist =false
//     clearInterval(this._timer)
//   }else if(name =='timeOut'){//暂停
//     this.TimeOut++
//     this.fist =false
//     clearInterval(this._timer)
//     if(this.TimeOut/2 == 1){
//       this._timer = setInterval(this.onlyAddmarker.bind(this), 800)
//     }
//   }
// }
//传入两个经纬度点得到车辆角度 设置车辆Marker角度
const getAngle = (startPoint, endPoint) => {
	if(!(startPoint && endPoint)) {
		return 0;
	}

	let dRotateAngle = Math.atan2(
		Math.abs(startPoint.lng - endPoint.lng),
		Math.abs(startPoint.lat - endPoint.lat)
	);
	if(endPoint.lng >= startPoint.lng) {
		if(endPoint.lat >= startPoint.lat) {} else {
			dRotateAngle = Math.PI - dRotateAngle;
		}
	} else {
		if(endPoint.lat >= startPoint.lat) {
			dRotateAngle = 2 * Math.PI - dRotateAngle;
		} else {
			dRotateAngle = Math.PI + dRotateAngle;
		}
	}
	dRotateAngle = (dRotateAngle * 180) / Math.PI;
	return dRotateAngle;
}
Tmap.prototype.onlyAddmarker = function(i) {
	if(this.marker) {
		this.map.removeOverLay(this.marker)
	}
	if(this.carMarker) {
		this.map.removeOverLay(this.carMarker)
	}
	var icon = null;
	if(this.workName && this.workName == '无人机植保') {
		icon = new T.Icon({
			iconUrl: require('../img/nongji2.png'),
			iconSize: new T.Point(40, 23),
			iconAnchor: new T.Point(30, 10)
		})
	} else {
		icon = new T.Icon({
			iconUrl: require('../img/nongji1.png'),
			iconSize: new T.Point(20, 40),
			iconAnchor: new T.Point(0, 0)
		})
	}

	let markPosition = this.i > 0 ? this.i - 1 : 0
	let currentLngLat;
	if(this.lineLog.length > 0) {
		currentLngLat = new T.LngLat(this.lineLog[markPosition].lng, this.lineLog[markPosition].lat)
		this.markerLngLat = new T.LngLat(this.lineLog[0].lng, this.lineLog[0].lat)
		this.marker = new T.Marker(currentLngLat, {
			icon: icon
		})

		let currentPoint = this.map.lngLatToContainerPoint(currentLngLat)

		if(currentPoint.x < 100 || currentPoint.y < 100 || currentPoint.x > 1024 || currentPoint.y > 1024) {
			this.map.setViewport(new Array(currentLngLat))
		}
		if(arrLog && arrLog === '') {
			arrLog = this.marker
		} else {
			this.map.removeOverLay(arrLog)
			arrLog = this.marker
		}
		this.map.addOverLay(this.marker)

		//	设置角度偏转以及行驶过的路线变为绿色
		if(markPosition > 0) {
			let lastLngLat = new T.LngLat(this.lineLog[markPosition - 1].lng, this.lineLog[markPosition - 1].lat)
			let angle = getAngle(lastLngLat, currentLngLat);
			if(angle > 30) {
				let len_ = document.getElementsByClassName('.el-dialog__wrapper tdt-marker-icon').length;
				if(document.getElementsByClassName('jobModule').length > 0) {
					let translateCss = document.getElementsByClassName('jobModule')[0].getElementsByClassName("tdt-marker-icon")[0].style.transform.split(' r')[0]
					document.getElementsByClassName('jobModule')[0].getElementsByClassName("tdt-marker-icon")[0].style.transform = translateCss + ' rotate(' + angle + 'deg)';
					this.lastLinePoints.push(new T.LngLat(this.lineLog[markPosition - 1].lng, this.lineLog[markPosition - 1].lat));
				}
			}
		}
		if(this.lastLine) {
			this.map.removeOverLay(this.lastLine)
			this.lastLine = ''
		}
		this.lastLine = new T.Polyline(this.lastLinePoints, {
			color: 'yellow'
		})
		this.map.addOverLay(this.lastLine)
		if(this.i >= this.lineLog.length) {
			clearInterval(this._timer)
			this.lineLog = []
			this.i = 0
			this.btnName = "开始"
			vm.$store.state.kName='';
			vm.$store.state.kName="end";
			this.fist = true;
			this.lastLinePoints = []
			this.map.removeOverLay(this.lastLine)
			this.marker.setLngLat(this.markerLngLat)
			// this.i = 0
		} else {
			this.i++;
			//		lineDatas.push(currentLngLat);
		}
	}

}
Tmap.prototype.playBack = function(pointArray, operationName, markerLastRunPosition, stopFlag, workName,speedNum) {
	this.workName = workName;
	if(operationName === 'start') {
		this.lineLog = pointArray;
		let markerPosition = markerLastRunPosition && markerLastRunPosition > 0 ? markerLastRunPosition : 0

		if(this.fist) {
			var points = []
			let redLineLen = stopFlag ? markerPosition : this.lineLog.length // 红线，已经跑过的
			for(var i = 0; i < redLineLen; i++) {
				points.push(new T.LngLat(this.lineLog[i].lng, this.lineLog[i].lat))
			}
			//创建线对象
			var line = new T.Polyline(points, {
				color: 'red'
			})
			points = []
			//向地图上添加线
			this.map.addOverLay(line)
			if(markerPosition === this.i && stopFlag) {
				var icon = null;
				if(workName && workName == '无人机植保') {
					icon = new T.Icon({
						iconUrl: require('../img/nongji2.png'),
						iconSize: new T.Point(40, 23),
						iconAnchor: new T.Point(30, 10)
					})
				} else {
					icon = new T.Icon({
						iconUrl: require('../img/nongji1.png'),
						iconSize: new T.Point(20, 40),
						iconAnchor: new T.Point(0, 0)
					})
				}
				this.markerLngLat = new T.LngLat(this.lineLog[markerPosition].lng, this.lineLog[markerPosition].lat)
				this.marker = new T.Marker(this.markerLngLat, {
					icon: icon
				})
				arrLog = this.marker
				this.map.addOverLay(this.marker)
			}
		}
	}
	if(operationName == 'start') { //开始 
		clearInterval(this._timer);
		//					this._CarTrack.start()
		this.btnName = '';
		this.i = 0
		this.fist = false
		this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)

	} else if(operationName == 'accelerate') { // 加速
		this.fist = false
		clearInterval(this._timer)
		this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
	} else if(operationName == 'slowdown') { //减速
		this.fist = false
		clearInterval(this._timer)
		this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
	} else if(operationName == 'stop') { //停止
		this.fist = true
		this.lineLog = []
		this.i = 0
		clearInterval(this._timer)
	} else if(operationName == 'pause') { //暂停
		this.fist = false
		this.i = markerLastRunPosition
		clearInterval(this._timer)
	} else if(operationName == 'continue') { //继续
		this.fist = false
		this.i = markerLastRunPosition
		this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
	}
}

export default Tmap


// WEBPACK FOOTER //
// ./src/map/js/fzTianmap.js